import { useNavigate } from 'react-router-dom';
import { Compass, ArrowRight } from 'lucide-react';

// Colorful, clickable "take the quiz" card — reused across the homepage, /courses,
// and every audience page so visitors are never more than one scroll from the quiz.
export const QuizPromptBanner = ({ testId = 'quiz-prompt-banner', style = {} }) => {
  const navigate = useNavigate();

  return (
    <section style={{ padding: '2rem 1rem 0' }}>
      <div
        data-testid={testId}
        onClick={() => navigate('/quiz')}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate('/quiz'); }}
        role="button"
        tabIndex={0}
        style={{
          maxWidth: '1140px',
          margin: '0 auto',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '1.25rem',
          flexWrap: 'wrap',
          background: 'linear-gradient(135deg, #5f7057 0%, #3d4d37 100%)',
          borderRadius: '18px',
          padding: 'clamp(1.25rem, 3vw, 1.75rem) clamp(1.25rem, 4vw, 2.25rem)',
          boxShadow: '0 14px 36px rgba(63,77,55,0.3)',
          ...style,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: '1 1 320px' }}>
          <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Compass size={24} color="#fff" />
          </div>
          <div style={{ textAlign: 'left' }}>
            <p style={{ margin: 0, color: '#fff', fontWeight: 800, fontSize: 'clamp(1rem, 2.4vw, 1.15rem)' }}>
              Not sure which course is right for you?
            </p>
            <p style={{ margin: '0.15rem 0 0', color: 'rgba(255,255,255,0.85)', fontSize: '0.9rem' }}>
              Take the free 90-second quiz — we'll point you to the exact course written for your situation.
            </p>
          </div>
        </div>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8, background: '#fff', color: '#3d4d37',
          fontWeight: 800, borderRadius: 999, padding: '0.8rem 1.5rem', fontSize: '0.95rem', whiteSpace: 'nowrap', flexShrink: 0
        }}>
          START HERE <ArrowRight size={16} />
        </div>
      </div>
    </section>
  );
};
